import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import HomeLanding from './pages/home-landing';
import Dashboard from './pages/dashboard';
import LaunchAgent from './pages/launch-agent';
import SettingsAdministration from './pages/settings-administration';
import IntegrationsManagement from './pages/integrations-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/authentication" element={<Authentication />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/launch-agent" element={<LaunchAgent />} />
        <Route path="/settings-administration" element={<SettingsAdministration />} />
        <Route path="/integrations-management" element={<IntegrationsManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
